import { either, option, string } from 'fp-ts';
import { pipe } from 'fp-ts/function';

export const emptyStringOptionToUndefined = (input: option.Option<string>): string | undefined =>
  pipe(
    input,
    option.map((value) => value ?? ''),
    either.fromOption(() => undefined),
    either.chain((value: string) =>
      string.isEmpty(value) ? either.left(undefined) : either.right(value),
    ),
    either.toUnion,
  );

export const emptyStringToUndefined = (input?: string): string | undefined =>
  pipe(input, option.fromNullable, emptyStringOptionToUndefined);
